export default "__VITE_ASSET__0723aa51__"